import { Stack, Title } from "@mantine/core";
import { useAdminDashboard } from "../hooks/useAdminDashboard";
import OverviewGrid from "./OverviewGrid";
import AccountDirectoryPanel from "./AccountDirectoryPanel";

export default function AdminDashboard() {
  const dashboard = useAdminDashboard();

  return (
    <Stack gap="xl" py="xl" m="md">
      <Title order={2} fw={900}>
        Bảng điều khiển quản trị
      </Title>

      <OverviewGrid stats={dashboard.stats} />

      <AccountDirectoryPanel {...dashboard} />
    </Stack>
  );
}
